module.exports = __webpack_public_path__ + "img/1.a6bfbe61.jpg";